// src/pages/WishlistPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ShoppingBag } from 'lucide-react';
import { useApp } from '../context/AppContext';
import ProductCard from '../components/ProductCard';

export default function WishlistPage() {
  const { user, wishlist } = useApp();

  if (!user) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-cream pt-20">
        <div className="text-5xl mb-2">💖</div>
        <h2 className="font-display font-bold text-2xl text-gray-800">Login to view wishlist</h2>
        <Link to="/login" className="bg-rose-500 text-white px-6 py-3 rounded-2xl hover:bg-rose-600 transition-colors font-medium">
          Login / Sign Up
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream pt-20 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <h1 className="font-display font-bold text-3xl text-gray-900 flex items-center gap-3">
            <Heart size={28} className="text-rose-500 fill-rose-500" />
            My Wishlist
            {wishlist.length > 0 && (
              <span className="bg-rose-100 text-rose-600 text-base font-bold px-3 py-1 rounded-full">
                {wishlist.length}
              </span>
            )}
          </h1>
        </div>

        {wishlist.length === 0 ? (
          <div className="bg-white rounded-3xl shadow-soft p-12 text-center">
            <div className="w-20 h-20 bg-rose-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart size={36} className="text-rose-300" />
            </div>
            <h3 className="font-display font-semibold text-xl text-gray-700 mb-2">Your wishlist is empty</h3>
            <p className="text-gray-400 font-body text-sm mb-6">Save your favourite gifts here 💕</p>
            <Link
              to="/products"
              className="inline-flex items-center gap-2 bg-rose-500 text-white px-8 py-3.5 rounded-2xl font-medium hover:bg-rose-600 transition-colors shadow-rose"
            >
              <ShoppingBag size={18} /> Browse Gifts
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {wishlist.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
